// extracted by mini-css-extract-plugin
export var blue = "_44-g";
export var brand = "_44-c";
export var darkGrey = "_44-f";
export var disabled = "_44-6";
export var disabledSubtle = "_44-7";
export var error = "_44-8";
export var green = "_44-h";
export var grey = "_44-e";
export var icon = "_44-0";
export var inherit = "_44-b";
export var lightGrey = "_44-d";
export var orange = "_44-j";
export var pink = "_44-l";
export var primary = "_44-1";
export var purple = "_44-m";
export var quaternary = "_44-4";
export var quinary = "_44-5";
export var red = "_44-k";
export var secondary = "_44-2";
export var success = "_44-a";
export var tertiary = "_44-3";
export var warning = "_44-9";
export var white = "_44-n";
export var yellow = "_44-i";